import React, { SVGProps } from "react";

const FontSizeSmallIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#66696D" {...props}>
    <path d="M29.384 35L25.08 24.328h-1.648L19.144 35h1.52l.944-2.368h5.312L27.864 35h1.52zm-2.864-3.552h-4.528l2.272-5.744 2.256 5.744z" />
  </svg>
);

export default FontSizeSmallIcon;
